<template>
  <el-select
    :value="selected"
    @input="dispatch"
    :placeholder="plc || $t('message.type_documents')"
    filterable
    clearable

  >
    <el-option v-for="item in documentTypes" :key="item.id" :label="item.name" :value="item.id"></el-option>
  </el-select>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import inventory from '@/utils/mixins/components/inventory';

export default {
  mixins: [inventory],
  props: ['document_type_id'],
  mounted() {
    if (this.documentTypes && this.documentTypes.length === 0) {
      this.getInventory();
    }
  },
  watch: {
    document_type_id:{
       handler: function (val, oldVal) { 
          this.selected = val;
          this.$emit("input", this.selected);
       },
       deep: true,
       immediate: true
    }
  },
  computed: {
    ...mapGetters({
      documentTypes: 'documentTypes/inventory',
    }),
  },
  methods: {
    ...mapActions({
      getInventory: 'documentTypes/inventory',
    })
  },
};
</script>
